// extracted by mini-css-extract-plugin
module.exports = {"header":"RegisterHeader_header__2Z-vY","headerTitle":"RegisterHeader_headerTitle__1O4bo","headerIcon":"RegisterHeader_headerIcon__Ym_9j"};